import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  create: async (data) => await apiClient.post(endpoints.create(), data),
  update: async (id, data) => await apiClient.put(endpoints.update(id), data),
  getById: async (id) => await apiClient.get(endpoints.getById(id)),
  getProviderEntityById: async (id) => await apiClient.get(endpoints.getProviderEntityById(id)),
  getAllByAgency: async (id, params) => await apiClient.get(endpoints.getAllByAgency(id), { params }),
  saveIdentifiers: async ({ id, ...params }) => await apiClient.put(endpoints.saveIdentifiers(id), params),
  getIdentifiers: async (id, params) => await apiClient.get(endpoints.getIdentifiers(id), { params }),
};
